module.exports = __webpack_public_path__ + "img/picto-identifier.e58a09f8.svg";